/**
 * Format a number as Indian Rupees (₹).
 * Uses the en-IN locale for proper Indian number formatting (lakhs, crores).
 * Example: 4201050 → ₹42,01,050.00
 */
export function formatINR(n) {
  return `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/**
 * Compact version without decimals for large numbers.
 * Example: 42010 → ₹42,010
 */
export function formatINRCompact(n) {
  return `₹${Math.round(Number(n || 0)).toLocaleString("en-IN")}`;
}
